import { createFileRoute, redirect } from '@tanstack/react-router';
import { leadsApi } from '@web/modules/leads/leads-api';

/**
 * The lead's page is gone (ADR 0019, spec 071, phase 3): an old link (a notification, the
 * audit log, a bookmark) lands on what the lead became — its opportunity, else its contact,
 * else the pipeline.
 */
export const Route = createFileRoute('/_app/leads/$leadId')({
  beforeLoad: async ({ params }) => {
    const lead = await leadsApi.get(params.leadId).catch(() => null);
    if (lead?.currentDealId) {
      throw redirect({
        to: '/deals/$dealId',
        params: { dealId: lead.currentDealId },
        replace: true,
      });
    }
    if (lead?.contact) {
      throw redirect({ to: '/contacts', search: { contactId: lead.contact.id }, replace: true });
    }
    throw redirect({ to: '/deals', search: {}, replace: true });
  },
});
